import { atom } from "recoil";
import { CrossdockStateKey } from "crossdock/base/CrossdockStateKey";

export const palletLabelIdState = atom<string>({
  key: CrossdockStateKey.TRANSFERS_REOPEN_PALLET_LABEL_ID,
  default: "",
});
